'use client';

import { createContext, ReactNode, useContext, useState } from 'react';

const disableScrolling = (which: 'left' | 'right' | 'search') => {
  document.body.classList.add('nav-open', which);
};

const enableScrolling = () => {
  document.body.classList.remove('nav-open', 'left', 'right');
};

interface MobileNavContextType {
  isOpen: boolean;
  toggleNav: () => void;
}

const MobileNavContext = createContext<MobileNavContextType | undefined>(
  undefined,
);

export function MobileNavProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  function toggleNav() {
    if (isOpen) {
      enableScrolling();
    } else {
      disableScrolling('left');
    }
    setIsOpen(!isOpen);
  }

  return (
    <MobileNavContext.Provider value={{ isOpen, toggleNav }}>
      {children}
    </MobileNavContext.Provider>
  );
}

export function useMobileNav() {
  const context = useContext(MobileNavContext);
  if (!context) {
    throw new Error('useMobileNav must be used within a MobileNavProvider');
  }
  return context;
}
